export function showGraphQLError(error: any): string {
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        return error.graphQLErrors[0].message;
    }

    if (error.networkError) {
        if (
            error.networkError.result &&
            error.networkError.result.errors &&
            error.networkError.result.errors.length > 0
        ) {
            return error.networkError.result.errors[0].message;
        }
        return error.networkError.message;
    }

    if (error.message) {
        return error.message;
    }

    return 'An unknown error occurred.';
}